import { breakpoints, useMediaQuery } from '@coursera/cds-core';

/**
 * @description This hook is used to determine if the current viewport is mobile or not.
 */
const useIsMobile = (): boolean => {
  const mobileBreakpoint = breakpoints.down('xs');
  const isMobile = useMediaQuery(mobileBreakpoint);

  return isMobile;
};

export default useIsMobile;
